import { fetchPost, fetchPut, fetchGet, fetchDelete } from '@/utils/request'

export function getCategories (query) {
    return fetchGet('/gateway/v1/news-categories', query)
}

export function editCategoriesStatus (id, query) {
    return fetchPut('/gateway/v1/news-categories/' + id + '/status', query)
}

export function editCategoriesSort (id, query) {
    return fetchPut('/gateway/v1/news-categories/' + id + '/sort', query)
}

export function editCategories (id, query) {
    return fetchPut('/gateway/v1/news-categories/' + id, query)
}

export function addCategories (query) {
    return fetchPost('/gateway/v1/news-categories', query)
}

export function getNewsList(query) {
    return fetchGet('/gateway/v1/news',query)
}

export function editNews(id,query) {
    return fetchPut('/gateway/v1/news/'+id,query)
}

export function deleteNews(id,query) {
    return fetchDelete('/gateway/v1/news/'+id,query)
}

export function addNews(id,query) {
    return fetchPost('/gateway/v1/news',query)
}